var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { m } from 'framer-motion';
import { useFlyoutVariants } from '../config';
const backgroundAlpha = (opacity) => `rgba(0,0,0,${opacity})`;
const closedState = {
    backdropFilter: 'blur(0px)',
    background: backgroundAlpha(0),
};
export const FlyoutMenuBackdrop = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const variants = useFlyoutVariants({
        initial: closedState,
        animate: {
            background: backgroundAlpha(0.44),
            backdropFilter: 'blur(15px)',
            WebkitBackdropFilter: 'blur(15px)',
        },
        exit: closedState,
    });
    return (React.createElement(m.div, Object.assign({}, props, variants, { ref: ref, key: "blur", layout: true, style: { position: 'fixed', width: '100%', height: '100%', zIndex: 6 } }), children));
});
//# sourceMappingURL=FlyoutMenuBackdrop.js.map